var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PromiseCache } from "@configura/web-utilities";
import { makeProductKey, makeSelOptionsKey, } from "./utilitiesCatalogueData.js";
/**
 * Wraps a getProduct function so that it caches for the time it lives.
 *
 * It has no cache invalidation or timeouts, so whatever ends up in the cache stays there
 * indefinitely. For this reason we recommend using this with caution.
 *
 * In our Example App we use it to cache the internal calls in additional products as in such a
 * product you tend to frequently get calls to same sub-product. Such as loading the same table leg
 * four times.
 */
export function wrapWithGetProductCache(getProduct) {
    const cache = new PromiseCache();
    return (params) => __awaiter(this, void 0, void 0, function* () { return cache.get(makeProductKey(params), () => getProduct(params)); });
}
/**
 * Wraps a postValidate function so that it caches for the time it lives.
 *
 * It has no cache invalidation or timeouts, so whatever ends up in the cache stays there
 * indefinitely. We recommend you do not use this unless you are really, really sure what you are
 * doing.
 *
 * The SDK uses it for additional products to avoid validating for example the same table legs four
 * times at the same time. There we make sure the this cache only stays in scope for one user
 * interaction. No longer than the actions caused by a user clicking an option.
 */
export function wrapWithPostValidateCache(postValidate) {
    const cache = new PromiseCache();
    return (params, body) => __awaiter(this, void 0, void 0, function* () {
        return cache.get(`${makeProductKey(params)}-${makeSelOptionsKey(body.selOptions)}-${body.knownFeatureCodes.join(",")}`, () => postValidate(params, body));
    });
}
/** Does both wrapWithGetProductCache and wrapWithPostValidateCache. */
export function wrapWithCache(loader) {
    return {
        getProduct: wrapWithGetProductCache(loader.getProduct.bind(loader)),
        postValidate: wrapWithPostValidateCache(loader.postValidate.bind(loader)),
    };
}
